/* tslint:disable */
/* eslint-disable */
/**
 * e-SNRWB
 * Opis api e-SNRWB
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReportInspected
 */
export interface ReportInspected {
    /**
     * 
     * @type {object}
     * @memberof ReportInspected
     */
    details: object;
    /**
     * 
     * @type {object}
     * @memberof ReportInspected
     */
    sum: object;
}

export function ReportInspectedFromJSON(json: any): ReportInspected {
    return ReportInspectedFromJSONTyped(json, false);
}

export function ReportInspectedFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportInspected {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'details': json['details'],
        'sum': json['sum'],
    };
}

export function ReportInspectedToJSON(value?: ReportInspected | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'details': value.details,
        'sum': value.sum,
    };
}


